export default "__VITE_ASSET__9e9513db__"